import { useMutation } from 'react-query'
import { api } from '../../../api'

const deleteTask = async (id: number) => {
  const response = await api.delete(`/tasks/${id}`)
  return response.data
}

export const useTaskDeleteMutation = () => {
  return useMutation({
    mutationFn (id: number) {
      return deleteTask(id)
    },
  })
}
